<div *ngIf="priceLevels.length > 1 && priceLevelsDisplayType !== 'FULL'" [ngClass]="priceLevelsDisplayType === 'COMPACT_LIST' ? 'd-inline' : ''">
  <span *ngIf="priceLevels[currentPrice + 1] && priceLevels[currentPrice + 1].quantity >= dataCart?.qty" [ngClass]="priceLevelsDisplayType === 'COMPACT_LIST' ? 'ml-2 remaining-text' : 'remaining-text'">{{ (priceLevels[currentPrice + 1].quantity - dataCart?.qty) | number : '1.0-2' }} <span translate>LEFT_FOR</span> {{ calculatePriceLevelNetPrice(priceLevels[currentPrice + 1].price, priceLevels[currentPrice + 1].discount) }}</span>
  <span ngbDropdown class="ml-2 remaining-text" container="body">
    <i ngbDropdownToggle class="fas fa-info-circle"></i>

    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="p-2">
      <table class="table">
        <tr>
          <th translate>QTY</th>
          <th translate>PRICE</th>
        </tr>
        <tr *ngFor="let level of priceLevels">
          <td>{{ level.quantity | number : '1.0-2' }}</td>
          <td>{{ calculatePriceLevelNetPrice(level.price, level.discount) }}</td>
        </tr>
      </table>
    </div>
  </span>
</div>

@if (priceLevels.length > 1 && priceLevelsDisplayType === 'FULL') {
  <div id="full-price-levels">
    @if (priceLevelsQuantities.length > 0 && priceLevelsPrices?.length > 0) {
      <div class="table-responsive gung-responsive w-100">
        <table class="table table-striped-mobile">
          <thead>
            <tr>
              <th translate>QUANTITY</th>
              @for(qty of priceLevelsQuantities; track qty) {
              <th>{{ qty | number: '1.0-2' }}+</th>
              }
            </tr>
          </thead>
          <tbody>
            <tr>
              <td [attr.data-label]="'QUANTITY' | translate">
                {{ 'PRICE' | translate }}
              </td>
              @for(data of priceLevelsPrices; track data) {
              <td [attr.data-label]="(data.qty | number: '1.0-2') + '+'">
                <lib-price [price]="data.price"></lib-price>
              </td>
              }
            </tr>
          </tbody>
        </table>
      </div>
    }
  </div>
}
